import { useState } from "react";
import { Copy, FileDown, History, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API, errMsg, useApi } from "@/lib/api";
import { hteToText } from "@/lib/hte";
import { useAuth } from "@clerk/react";

const ACTION_LABEL = { jana: "Dijana", laras: "Dilaras", pulih: "Dipulihkan", sunting: "Disunting", templat: "Daripada templat" };

const Btn = ({ onClick, disabled, testid, children }) => (
  <button onClick={onClick} disabled={disabled} data-testid={testid}
    className="h-11 px-5 rounded-full border border-line text-sm inline-flex items-center gap-2 hover:bg-surface transition-colors disabled:opacity-40">{children}</button>
);

export const ResultActions = ({ kajian, onUpdated, busy, owner }) => {
  const api = useApi();
  const { getToken } = useAuth();
  const [pdfBusy, setPdfBusy] = useState(false);
  const [restoring, setRestoring] = useState(false);
  const d = kajian.current;
  const last = kajian.versions[kajian.versions.length - 1];
  const canRestore = (last.restored_from || last.n) > 1;

  const copy = async () => {
    try { await navigator.clipboard.writeText(hteToText(d)); toast.success("Disalin sebagai teks"); }
    catch { toast.error("Gagal menyalin"); }
  };
  const downloadPdf = async () => {
    setPdfBusy(true);
    try {
      const r = await fetch(`${API}/hte/kajian/${kajian.id}/pdf`, { headers: { Authorization: `Bearer ${await getToken()}` } });
      if (!r.ok) throw new Error();
      const blob = await r.blob();
      const m = /filename\*=UTF-8''([^;]+)/.exec(r.headers.get("content-disposition") || "");
      const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(blob), download: m ? decodeURIComponent(m[1]) : "HTE.pdf" });
      a.click();
      URL.revokeObjectURL(a.href);
    } catch { toast.error("Gagal menjana PDF. Cuba lagi."); } finally { setPdfBusy(false); }
  };
  const restore = async () => {
    setRestoring(true);
    try { onUpdated(await api("post", `/hte/kajian/${kajian.id}/restore`, {})); toast.success("Versi sebelum dipulihkan"); }
    catch (e) { toast.error(errMsg(e)); } finally { setRestoring(false); }
  };

  return (
    <div className="space-y-3">
      <div className="font-mono-data text-xs text-mute" data-testid="version-label">
        Versi {last.n} · {ACTION_LABEL[last.action] || last.action}{last.layer ? ` lapis ${last.layer.toUpperCase()}` : ""}{last.restored_from ? ` dari versi ${last.restored_from}` : ""}
      </div>
      <div className="flex flex-wrap gap-3">
        <Btn onClick={downloadPdf} disabled={pdfBusy || busy} testid="download-pdf-button">
          {pdfBusy ? <Loader2 size={15} className="animate-spin" /> : <FileDown size={15} />} Muat turun PDF
        </Btn>
        <Btn onClick={copy} testid="copy-text-button"><Copy size={15} /> Salin sebagai teks</Btn>
        {owner && <Btn onClick={restore} disabled={!canRestore || restoring || busy} testid="restore-version-button">
          {restoring ? <Loader2 size={15} className="animate-spin" /> : <History size={15} />} Kembali ke versi sebelum
        </Btn>}
      </div>
    </div>
  );
};
